export const RANK_EQUITY_LIST = 'RANK_EQUITY_LIST'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/rank-equity/store/mutations-types.js